import React from 'react';
import './ImgSlide.css';

const ImgSlide = (props) => {
    let {
        isCurrentSlide,
        source: {
            path,
            background = ''
        }
    } = props;

    let style = {
        backgroundImage: `url(${ path })`,
        backgroundColor: background
    };

    return (
        <div className={ `b-slide ${ isCurrentSlide ? 'b-slide--active' : '' }` }>
            <div
                className="b-img-slide"
                style={ style }
            >
            </div>
        </div>
    );
};

export default ImgSlide;
